import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function unpublishTripsJourneys(input: { dateIds: number[]; tripIds: number[] }) {
  return restApiClient.url(constructApiUrl(API.trips.unpublishTripsJourneys.url, null)).post(input)
}
